import { combineReducers } from 'redux';

import { Telco } from './TelcoReducer';
import { Itr } from './ITRReducer';
import { Gst } from './GSTReducer';
import { perfios } from './PerfiosReducer';

const rootReducer = combineReducers({
    Telco,
    Itr,
    Gst,
    perfios
});

export default rootReducer;